/**
 * 03/11/2026 (Quân): "chừa đường để admin tác động nút on/off trong tài khoản chủ chuỗi" — ba công tắc
 * quyền tiền của chuỗi, đúng như chủ chuỗi thấy ở tab Trạm → Quyền của chuỗi. Máy chủ ép cùng luật
 * (chuỗi nhiều bên ký không tắt được; trạm tự sửa TK ⇒ tắt "một tài khoản chung"). Mỗi lần đổi có nhật ký.
 */
import React, { useEffect, useState } from "react";
import { apiErrorText, ChainPermissions, getChainPermissions, setChainPermissions } from "../../../../services/LegalEntityService";

const NHAN: { key: keyof ChainPermissions; label: string }[] = [
	{ key: "locationsCanRequestPayout", label: "Stations can request payouts" },
	{ key: "locationsCanEditPayoutAccount", label: "Stations can edit their payout account (and upload the authorisation letter)" },
	{ key: "sharedPayoutAccount", label: "One payout account for every station" },
];

export default function ChainPermissionsAdmin({ storeId, onNotice }: { storeId: number; onNotice: (n: { tone: "ok" | "err"; text: string }) => void }) {
	const [q, setQ] = useState<ChainPermissions | null>(null);
	const [busy, setBusy] = useState(false);
	useEffect(() => {
		getChainPermissions(storeId)
			.then(setQ)
			.catch((e) => onNotice({ tone: "err", text: apiErrorText(e) }));
	}, [storeId, onNotice]);

	const doi = async (key: keyof ChainPermissions) => {
		if (!q) return;
		const moi = !q[key];
		const nhan = NHAN.find((n) => n.key === key)?.label || key;
		if (!window.confirm(`Chain #${storeId}: turn ${moi ? "ON" : "OFF"} “${nhan}”?\n\nThe chain owner sees the change straight away.`)) return;
		setBusy(true);
		try {
			setQ(await setChainPermissions(storeId, { [key]: moi, reason: "Admin" }));
			onNotice({ tone: "ok", text: `Chain #${storeId}: “${nhan}” is now ${moi ? "ON" : "OFF"}.` });
		} catch (e) {
			onNotice({ tone: "err", text: apiErrorText(e) });
		} finally {
			setBusy(false);
		}
	};

	if (!q) return <span style={{ color: "#667085", fontSize: 13 }}>Loading chain permissions…</span>;
	return (
		<div data-testid={`chain-perms-${storeId}`} style={{ display: "grid", gap: 4, padding: "8px 0", borderTop: "1px solid #eaecf0", marginTop: 4 }}>
			<b style={{ fontSize: 12, color: "#344054" }}>Chain permissions</b>
			{NHAN.map((n) => {
				const khoaChung = n.key === "sharedPayoutAccount" && q.locationsCanEditPayoutAccount;
				return (
					<label key={n.key} style={{ display: "flex", gap: 6, alignItems: "flex-start", fontSize: 12, color: khoaChung ? "#98a2b3" : "#344054" }}>
						<input type="checkbox" checked={Boolean(q[n.key])} disabled={busy || khoaChung} onChange={() => doi(n.key)} />
						<span>{n.label}</span>
					</label>
				);
			})}
		</div>
	);
}
